var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompassImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.387 2.4V0H10.842V2.4C9.90207 2.59181 9.06683 3.12581 8.49824 3.89845C7.92965 4.6711 7.6682 5.62734 7.7646 6.5818C7.86099 7.53626 8.30835 8.42092 9.01995 9.06427C9.73155 9.70762 10.6567 10.0638 11.616 10.0638C12.5753 10.0638 13.5005 9.70762 14.2121 9.06427C14.9237 8.42092 15.371 7.53626 15.4674 6.5818C15.5638 5.62734 15.3024 4.6711 14.7338 3.89845C14.1652 3.12581 13.3299 2.59181 12.39 2.4H12.387Z",
    fill: "#722ED1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8 17.0319H21.681V15.4839H19.021L15.974 9.39694C15.3365 10.2632 14.4564 10.9209 13.445 11.2869L15.545 15.4869H12.387V13.9349H10.839V15.4829H7.682L9.782 11.2829C8.77053 10.9171 7.89037 10.2594 7.253 9.39294L4.2 15.4839H1.548V17.0319H3.429L0 23.8809C0.878326 24.1005 1.80527 24.014 2.62777 23.6356C3.45028 23.2573 4.11917 22.6097 4.524 21.7999L6.908 17.0329H10.839V18.5809H12.387V17.0319H16.318L18.7 21.7999C19.1048 22.6097 19.7737 23.2573 20.5962 23.6356C21.4187 24.014 22.3457 24.1005 23.224 23.8809L19.8 17.0319Z",
    fill: "#722ED1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompassImg);
export default __webpack_public_path__ + "static/media/compass-img.06ef42eb9616aeb0f05c71275df52b9b.svg";
export { ForwardRef as ReactComponent };